import { useState } from "react"
import styled from "styled-components"

import { ClaimForm } from "./ClaimForm"
import { ClaimSuccess } from "./ClaimSuccess"
import { HeroIntro } from "./HeroIntro"
import { tabletBreakpoint } from "./shared"

const HeroSection = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 48px;
  max-width: 1180px;
  margin: 0 auto;
  padding: 48px 24px 96px;

  @media only screen and (width <= ${tabletBreakpoint}) {
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 64px;
  }
`

export const Hero = () => {
  const [isSubmitted, setSubmitted] = useState(false)

  return (
    <HeroSection>
      <HeroIntro />
      {isSubmitted ? <ClaimSuccess /> : <ClaimForm onSuccess={() => setSubmitted(true)} />}
    </HeroSection>
  )
}
